import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";

import { bondingLabel } from "../../../../../../../../data/buildingPermit/fieldDatas";
import { fieldsToCheckBonding } from "../../../../../../../../data/permitFormsData";

const BONDING_FIELD_NAMES = ["bonding_name", "bonding_address"];

const RenderBonding = ({ full_title, bonding, onChange, fields }) => {
  const hasValidatedOnce = useRef(false);

  const savedProjects = useSelector((state) => state.nocData?.saved_projects);
  const { createDocLoading, addingNewBonding } = useSelector(
    (state) => state.buildingState,
  );

  const [bondingList, setBondingList] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    setBondingList(savedProjects?.bonding || []);
    setLoadingData(false);
  }, [savedProjects?.bonding]);

  // Index fields by name once per render — O(1) lookups below
  const fieldMap = useMemo(
    () => Object.fromEntries((fields || []).map((f) => [f.name, f])),
    [fields],
  );

  useEffect(() => {
    // Run only if we haven’t validated AND bondingList has loaded
    if (!hasValidatedOnce.current && bondingList.length > 0 && bonding) {
      const selectedId = bonding?.value;
      const selected = bondingList.find((pro) => pro.id === selectedId);

      if (!selected) {
        onChange("bondingCompany", "");
        BONDING_FIELD_NAMES.forEach((name) => onChange(name, ""));
      }

      hasValidatedOnce.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bondingList, bonding]);

  const handleSelectChange = (event) => {
    const selectedId = event.target.value;
    const selected = bondingList.find((p) => p.id === selectedId);

    onChange("bondingCompany", {
      value: selectedId,
      label: selected?.["bonding_name"],
    });
    BONDING_FIELD_NAMES.forEach((name) =>
      onChange(name, selected?.[name] || ""),
    );
  };

  const selectedPro = bondingList?.find((pro) => pro.id === bonding?.value);

  if (loadingData) {
    return <Skeleton variant="rectangular" height={120} />;
  }
  return (
    <>
      <Typography align="center" mt={2} mb={0} variant="h6">
        {full_title}
      </Typography>

      <FormControl
        fullWidth
        margin="normal"
        variant="filled"
        sx={{
          "& .MuiFilledInput-root": {
            border: bonding ? "2px solid #004976" : undefined, // adjust thickness and color
            borderRadius: "14px",
            backgroundColor: "transparent", // optional
          },
          "& .MuiFilledInput-underline:before": {
            borderBottom: "none", // remove default bottom border
          },
          "& .MuiFilledInput-underline:after": {
            borderBottom: "none",
          },
        }}
      >
        <InputLabel>Select Bonding Company</InputLabel>
        <Select
          disabled={createDocLoading || addingNewBonding}
          name="bondingCompany"
          value={bonding?.value || ""}
          onChange={handleSelectChange}
          MenuProps={{
            PaperProps: {
              style: {
                marginTop: "1.5px",
                maxHeight: 200,
                width: "auto",
                maxWidth: "100%",
              },
            },
          }}
        >
          <MenuItem disabled value="">
            {bondingList.length === 0 ? "No records found" : "Select One"}
          </MenuItem>
          {bondingList?.map((option, i) => (
            <MenuItem key={option.id + i} value={option.id}>
              {option.bonding_name || "Unnamed"}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {bonding && selectedPro && (
        <>
          {fieldsToCheckBonding?.map((field, i) => (
            <TextField
              key={field + i}
              fullWidth
              margin="normal"
              variant="filled"
              label={bondingLabel[field]}
              name={field}
              value={
                field === "bonding_name"
                  ? bonding?.label
                  : fieldMap[field]?.value || ""
              }
              disabled={!addingNewBonding}
            />
          ))}
        </>
      )}
      {/* <Box sx={{ border: "2px solid #d3d3d3" }} mt={1}></Box> */}
    </>
  );
};

export default RenderBonding;
